import React, { PropTypes, Component } from 'react';
import { Dialog } from 'material-ui';
import { connect } from 'react-redux';
import {
  saveSupplierInfoChanges,
  cancelEdit,
  onTextFieldChange,
  attachInsFile,
  removeInsFile,
  saveBillingInfoChanges,
} from '../__storeFiles__/actions';
import BillingInfo from '../../contract-activities-products/add-edit-dialog-content/billing-info';
import EditCheckInOut from '../../contract-activities-products/add-edit-dialog-content/edit-checkin-checkout';
import ExtraPolicyDivs from '../../contract-activities-products/add-edit-dialog-content/extra-policy-divs';
import TermsAndCriteria from '../../contract-activities-products/add-edit-dialog-content/terms-criteria';

const propTypes = {
  editDialog: PropTypes.object,
  onRequestClose: PropTypes.func,
  saveSupplierInfoChanges: PropTypes.func,
};
class AddEditDialog extends Component {
  render() {
    const {
      editDialog,
      ...extraProps,
    } = this.props;
    const { open, note, type, data = {}, saving, example } = editDialog;
    const ContentNode = (() => {
      switch (type) {
        case 'billingInfo':
          return BillingInfo;
        case 'checkInOut':
          return EditCheckInOut;
        case 'policy':
          return ExtraPolicyDivs;
        case 'corporateIdentificationNumber':
        case 'termsAndConditions':
        case 'submissionCriteria':
        case 'marketInfo':
          return TermsAndCriteria;
        default:
          return 'div';
      }
    })();
    const px550 = {
      submissionCriteria: 'submissionCriteria',
      termsConditions: 'termsConditions',
      billingInfo: 'billingInfo',
      policy: data.policyType !== 'cancellation',
    };
    const percent45 = {
      checkInOut: 'checkInOut',
    };
    const percent30 = {
      policy: data.policyType === 'cancellation',
    };

    const width = (() => {
      if (px550[type]) return '550px';
      if (percent45[type]) return '45%';
      if (!percent30[type]) return '30%';
      return '100%';
    })();
    const propsForContent = {
      data,
      saving,
      note,
      example,
      ...extraProps,
    };
    return (
      <Dialog
        autoScrollBodyContent
        bodyStyle={{ padding: '0', paddingBottom: '12px' }}
        contentStyle={{ maxWidth: '880px', width }}
        open={open}
        title={
          data.title ? <div style={{ backgroundColor: '#00BCD4', color: 'white', fontSize: '18px', padding: '16px 2%' }} >
            {data.title}
          </div> : undefined}
      >
        <ContentNode
          {...propsForContent}
        />
      </Dialog>
    );
  }
}

AddEditDialog.propTypes = propTypes;

const mapStateToProps = ({ contracting: { masterTemplate } }) => {
  return {
    editDialog: masterTemplate.editDialog,
  };
};

const mapDispatchToProps = ({
  saveSupplierInfoChanges,
  onRequestClose: cancelEdit,
  onTextFieldChange,
  attachInsFile,
  removeInsFile,
  saveBillingInfoChanges,
});

export default connect(mapStateToProps, mapDispatchToProps)(AddEditDialog);



// WEBPACK FOOTER //
// ./src/app/components/contracting/master-template/dialogs/edit-dialog.jsx